import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from "prop-types";
import { 
         Typography, 
         Tree, 
         Icon, 
         Switch,
         Row, 
         Col, 
         Spin, 
         Card, 
         Collapse, 
         Timeline, 
         Form, 
         Input, 
         Button 
} from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import imgcontact from '../../../../assets/images/contact.jpg'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import { workforce, getToken } from '../../../../utils/auth';
import axios from 'axios';
import { apiKeyNews } from '../../../../utils/apiKey'

const { Text, Title } = Typography
const { Panel } = Collapse;
const { TreeNode } = Tree;

class DashBoradOrgList extends React.Component {

    state = {
        dataContact: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        preLoadShow: false
    }

    async componentDidMount() {
       console.log('111')
      //  await this.getOrgList()
      //   await this.fetchListContactUsCategory()
    }


    onSelect = (selectedKeys, event) => {
      const { match, viewDetailEmpList, dataContact } = this.props
      console.log('selected', event);
      // viewDetailEmpList(
      //       valuesChild.orgUnitCode,
      //       values.orgUnitCode+' - '+values.orgUnitName+' / '+valuesChild.orgUnitCode+' - '+valuesChild.orgUnitName
      //    )
    };

    onChange = (test) =>{
      console.log('test', test)
    }

    render() {
        const { match, viewDetailEmpList, dataContact } = this.props
        const { preLoadShow } = this.state
        const { getFieldDecorator } = this.props.form;
        console.log('dataContact empCode', dataContact)
        return (
            <>
               <Row gutter={20} className="mt-3">
                     {
                           dataContact.length !== 0 &&
                           <Tree
                              // showLine
                              switcherIcon={<Icon type="down" />}
                              className="tree-custom-contact"
                           >
                                 {
                                 dataContact.map((values, keys) =>
                                    <TreeNode 
                                       title={
                                          <span 
                                          onClick={
                                                ()=> viewDetailEmpList(
                                                      values.orgUnitCode,
                                                      values.orgUnitCode+' - '+values.orgUnitName,
                                                      values.isCustom
                                                   )
                                             }
                                          >
                                                {
                                                   values.orgUnitName ? values.orgUnitCode+' '+values.orgUnitName : ""
                                                }
                                          </span>
                                       }  
                                       key={keys}
                                    >
                                       {
                                          values.childList.map((valuesChild, keysChild) =>
                                             keysChild > 0 &&
                                                <TreeNode 
                                                   title={
                                                      <span 
                                                         onClick={
                                                            ()=> viewDetailEmpList(
                                                                  valuesChild.orgUnitCode,
                                                                  values.orgUnitCode+' - '+values.orgUnitName+' / '+valuesChild.orgUnitCode+' - '+valuesChild.orgUnitName,
                                                                  values.isCustom
                                                               )
                                                         }
                                                      >
                                                         {
                                                            valuesChild.orgUnitName ? valuesChild.orgUnitCode+' '+valuesChild.orgUnitName : ""
                                                         }
                                                      </span> 
                                                   }
                                                   key={`${keys}-${keysChild}`}
                                                >
                                                   {
                                                      valuesChild.subChildList.length > 0 &&
                                                      valuesChild.subChildList.map((valuesChildList, keysChildList) =>
                                                      keysChildList > 0 &&
                                                         <TreeNode 
                                                            title={
                                                               <span 
                                                                  onClick={
                                                                     ()=> viewDetailEmpList(
                                                                           valuesChildList.orgUnitCode,
                                                                           values.orgUnitCode+' - '+values.orgUnitName+' / '+valuesChild.orgUnitCode+' - '+valuesChild.orgUnitName+' / '+valuesChildList.orgUnitCode+' - '+valuesChildList.orgUnitName,
                                                                           values.isCustom
                                                                        )
                                                                  }
                                                                  
                                                               >
                                                                  {
                                                                     valuesChildList.orgUnitName ? valuesChildList.orgUnitCode+' '+valuesChildList.orgUnitName : ""
                                                                  }
                                                               </span>  
                                                            }
                                                            key={`${keys}-${keysChild}-${keysChildList}`}
                                                         >
                                                            {
                                                      valuesChildList.lastChildList.length > 0 &&
                                                      valuesChildList.lastChildList.map((valuesLastChildList, keysLastChildList) =>
                                                      keysLastChildList > 0 &&
                                                         <TreeNode 
                                                            title={
                                                               <span 
                                                                  onClick={
                                                                     ()=> viewDetailEmpList(
                                                                        valuesLastChildList.orgUnitCode,
                                                                           values.orgUnitCode+' - '+values.orgUnitName+' / '+valuesChild.orgUnitCode+' - '+valuesChild.orgUnitName+' / '+valuesChildList.orgUnitCode+' - '+valuesChildList.orgUnitName+' / '+valuesLastChildList.orgUnitCode+' - '+valuesLastChildList.orgUnitName,
                                                                           values.isCustom
                                                                        )
                                                                  }
                                                                  
                                                               >
                                                                  {
                                                                     valuesLastChildList.orgUnitName ? valuesLastChildList.orgUnitCode+' '+valuesLastChildList.orgUnitName : ""
                                                                  }
                                                               </span>  
                                                            }
                                                            key={`${keys}-${keysChild}-${keysChildList}-${keysLastChildList}`}
                                                         >
                                                         </TreeNode>
                                                      )
                                                   }
                                                         </TreeNode>
                                                      )
                                                   }
                                                   
                                                </TreeNode>
                                       )}
                                    </TreeNode>
                                 )}
                              </Tree>
                           // <Collapse 
                           //    accordion
                           // >
                           //    {
                           //       dataContact.map((values, keys) =>
                           //          <Panel 
                           //             header={ <span onClick={() => alert('123132')}>{values.orgUnitName ? values.orgUnitCode+' '+values.orgUnitName : ""}</span>} 
                           //             key={keys}
                           //             className="custom-Panel-form"
                           //          >
                           //             <Timeline className="custom-timeline-form">
                           //                {
                           //                   values.childList.map((valuesChild, keysChild) =>
                           //                      <Timeline.Item 
                           //                         style={{ cursor:"pointer" }} 
                           //                         onClick={ () => 
                           //                                  viewDetailEmpList(
                           //                                     valuesChild.orgUnitCode,
                           //                                     values.orgUnitCode+' - '+values.orgUnitName+' / '+valuesChild.orgUnitCode+' - '+valuesChild.orgUnitName
                           //                                  ) 
                           //                               }
                           //                      >
                           //                         {valuesChild.orgUnitName ? valuesChild.orgUnitCode+' '+valuesChild.orgUnitName : ""} 
                           //                      </Timeline.Item>
                           //                   )
                           //                }
                           //             </Timeline>
                           //          </Panel>
                           //    )}
                           // </Collapse>
                           ||
                              dataContact.length == 0 &&
                              <div style={{ textAlign:"center" }}>
                                    <Text className="color-gray" >ไม่พบข้อมูล</Text>
                              </div>
                           ||
                              preLoadShow &&
                              <Col align="center" className="mt-5">
                                 <Spin size="large" />
                              </Col>
                     }
                  </Row>
            </>
        )
    }
}
DashBoradOrgList.defaultProps = {
   autoFocus: false,
 };
 
 DashBoradOrgList.propTypes = {
   afterSubmit: PropTypes.func,
   forgotLink: PropTypes.string,
   autoFocus: PropTypes.bool,
 };
 
 const WrappedDashBoradOrgList = Form.create()(DashBoradOrgList);
 
 export default withApollo(WrappedDashBoradOrgList);